var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { computedFrom } from "aurelia-binding";
var BaseWorkflowActivityAssignmentViewModel = /** @class */ (function () {
    function BaseWorkflowActivityAssignmentViewModel(dialogClientService, i18N, workflowAssignmentsService) {
        this.dialogClientService = dialogClientService;
        this.i18N = i18N;
        this.workflowAssignmentsService = workflowAssignmentsService;
        this.showUserAndDepartment = true;
        this.showStatus = true;
    }
    Object.defineProperty(BaseWorkflowActivityAssignmentViewModel.prototype, "item", {
        get: function () {
            return this._model.item;
        },
        enumerable: false,
        configurable: true
    });
    ;
    Object.defineProperty(BaseWorkflowActivityAssignmentViewModel.prototype, "reload", {
        get: function () {
            return this._model.reload;
        },
        enumerable: false,
        configurable: true
    });
    ;
    Object.defineProperty(BaseWorkflowActivityAssignmentViewModel.prototype, "assignment", {
        get: function () {
            return this._model.assignment;
        },
        enumerable: false,
        configurable: true
    });
    ;
    Object.defineProperty(BaseWorkflowActivityAssignmentViewModel.prototype, "entityTypeId", {
        get: function () {
            return this._model.entityTypeId;
        },
        enumerable: false,
        configurable: true
    });
    ;
    Object.defineProperty(BaseWorkflowActivityAssignmentViewModel.prototype, "isUpcomingAssignment", {
        get: function () {
            return this._model.isUpcomingAssignment;
        },
        enumerable: false,
        configurable: true
    });
    ;
    BaseWorkflowActivityAssignmentViewModel.prototype.activate = function (model) {
        if (!model) {
            return;
        }
        this._model = model;
        this.onActivated();
    };
    BaseWorkflowActivityAssignmentViewModel.prototype.cancelWorkflow = function () {
        var _this = this;
        if (!window["SystemJS"]) {
            require("" + "app/views/components/workflow-for-entity/dialogs/workflow-cancellation-dialog");
        }
        this.dialogClientService.show("app/views/components/workflow-for-entity/dialogs/workflow-cancellation-dialog", {
            title: this.i18N.tr('workflow-text'),
            cancel: function () {
                _this.dialogClientService.hide();
            },
            submit: function (cancellationReasonId, isReject, cancellationNotes) {
                _this.dialogClientService.hide();
                _this.workflowAssignmentsService.cancelWorkflow(_this.assignment.workflowStateId, cancellationReasonId, cancellationNotes).then(function (x) {
                    _this.reload(x.workflowState);
                });
            }
        });
    };
    BaseWorkflowActivityAssignmentViewModel.prototype.onActivated = function () { };
    __decorate([
        computedFrom('_model'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], BaseWorkflowActivityAssignmentViewModel.prototype, "item", null);
    __decorate([
        computedFrom('_model'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [])
    ], BaseWorkflowActivityAssignmentViewModel.prototype, "reload", null);
    __decorate([
        computedFrom('_model'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], BaseWorkflowActivityAssignmentViewModel.prototype, "assignment", null);
    __decorate([
        computedFrom('_model'),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [])
    ], BaseWorkflowActivityAssignmentViewModel.prototype, "entityTypeId", null);
    __decorate([
        computedFrom('_model'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], BaseWorkflowActivityAssignmentViewModel.prototype, "isUpcomingAssignment", null);
    return BaseWorkflowActivityAssignmentViewModel;
}());
export { BaseWorkflowActivityAssignmentViewModel };
